/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Error_Loading_DocumentInputs */

const en_read_along_error_loading_document = /** @type {(inputs: Read_Along_Error_Loading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading document`)
};

const es_read_along_error_loading_document = /** @type {(inputs: Read_Along_Error_Loading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar el documento`)
};

/**
* | output |
* | --- |
* | "Error loading document" |
*
* @param {Read_Along_Error_Loading_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_error_loading_document = /** @type {((inputs?: Read_Along_Error_Loading_DocumentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Error_Loading_DocumentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_error_loading_document(inputs)
	return en_read_along_error_loading_document(inputs)
});